import { render, staticRenderFns } from "./PoDetailsModal.vue?vue&type=template&id=2e8286bf&scoped=true"
import script from "./PoDetailsModal.vue?vue&type=script&lang=js"
export * from "./PoDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./PoDetailsModal.vue?vue&type=style&index=0&id=2e8286bf&lang=css"
import style1 from "./PoDetailsModal.vue?vue&type=style&index=1&id=2e8286bf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8286bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8286bf')) {
      api.createRecord('2e8286bf', component.options)
    } else {
      api.reload('2e8286bf', component.options)
    }
    module.hot.accept("./PoDetailsModal.vue?vue&type=template&id=2e8286bf&scoped=true", function () {
      api.rerender('2e8286bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/customer-service/components/Modal/PoDetailsModal.vue"
export default component.exports